/* global jQuery */

import * as React from "react";

import throttle from "lodash/throttle";

type Props = {
  following: boolean;
  children: React.ReactNode;
  el: string;
  onManualScroll: (evt: JQueryEventObject) => unknown;
};

export default class ScrollFollower extends React.PureComponent<Props> {
  // @ts-expect-error - TS2564 - Property '_heightMonitorInterval' has no initializer and is not definitely assigned in the constructor.
  _heightMonitorInterval: number;
  _ignoreScrollEvent: boolean | null | undefined;
  _scrollThrottler?: (evt: JQueryEventObject) => unknown;
  _previousHeight: number | null | undefined;

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.following && nextProps.following) {
      // Switching to following
      this.enableFollowing();
    } else if (this.props.following && !nextProps.following) {
      // Turning off following
      this.disableFollowing();
    }
  }

  componentWillUnmount() {
    if (this.props.following) {
      this.disableFollowing();
    }
  }

  render() {
    return <div className="ScrollFollowerComponent">{this.props.children}</div>;
  }

  scrollToBottom() {
    // @ts-expect-error - No overload matches this call
    const $output = jQuery(this.getElement() || undefined);
    const $window = jQuery(window);

    // The bottom of the window should be aligned to the bottom of the output
    const verticalPosition =
      // @ts-expect-error - TS2531 - Object is possibly 'null'.
      $output.offset().top + $output.outerHeight() - $window.height();

    // Scroll to the position on the page, but set a flag so we know in the
    // onWindowScroll function we know the difference between and auto scroll,
    // and a manual scroll.
    this._ignoreScrollEvent = true;

    return window.scrollTo(0, verticalPosition);
  }

  getElement() {
    return document.getElementById(this.props.el);
  }

  enableFollowing() {
    // Monitor scrolling, but ensure it's throttled so we don't slow everything
    // down.
    this._scrollThrottler = throttle(this.handleWindowScroll, 500);
    // @ts-expect-error Types of parameters 'evt' and 't' are incompatible.
    jQuery(window).bind("scroll", this._scrollThrottler || undefined);

    // Monitor the height of the document
    // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
    this._heightMonitorInterval = setInterval(
      this.handleHeightMonitorTick,
      200,
    );

    // Also jump to the bottom of the log
    this.scrollToBottom();
  }

  disableFollowing() {
    // @ts-expect-error - handler signature is incompatible.
    jQuery(window).unbind("scroll", this._scrollThrottler);
    delete this._scrollThrottler;

    clearInterval(this._heightMonitorInterval);
    // @ts-expect-error - TS2790 - The operand of a 'delete' operator must be optional.
    delete this._heightMonitorInterval;
  }

  handleWindowScroll = (evt: JQueryEventObject) => {
    if (this._ignoreScrollEvent) {
      delete this._ignoreScrollEvent;
    } else {
      this.props.onManualScroll(evt);
    }
  };

  handleHeightMonitorTick = () => {
    if (!document.body) {
      return;
    }

    const newHeight = document.body.clientHeight;

    // If the clientHeight changes, re-scroll to the element.
    if (this._previousHeight && this._previousHeight !== newHeight) {
      this.scrollToBottom();
    }

    this._previousHeight = newHeight;
  };
}
